(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseDeleteController',SurveyResponseDeleteController);

    SurveyResponseDeleteController.$inject = ['$uibModalInstance', 'entity', 'SurveyResponse'];

    function SurveyResponseDeleteController($uibModalInstance, entity, SurveyResponse) {
        var vm = this;
        vm.surveyResponse = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SurveyResponse.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
